import { useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useInvoiceStatusQuery } from '../../../../api/gql';
import { useSafeNavigation } from '../../../../hooks/useSafeNavigation';
import { theme } from '../../../../style/theme';
import { getInvoiceStateProperties } from '../../../../utils/invoice';

export const InvoiceAnnotationLoading = () => {
  const { invoiceId } = useParams();
  const { t } = useTranslation('page-annotation-loading');
  const { safeNavigate } = useSafeNavigation();
  const isMounted = useRef(true);

  const { data } = useInvoiceStatusQuery(
    {
      id: invoiceId ?? '',
    },
    {
      refetchInterval: 1000,
      enabled: isMounted.current,
    },
  );

  useEffect(() => {
    // Set mounted flag
    isMounted.current = true;

    // Cleanup function
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!data || !isMounted.current) {
      return;
    }
    const {
      invoice: { status, id, isAnnotated, batchUpload },
    } = data;
    const batchId = batchUpload?.id && !batchUpload.planPaid ? batchUpload.id : '';
    const route = getInvoiceStateProperties(status, id, batchId, batchUpload?.type, isAnnotated).route;

    // Make sure component is still mounted before navigating
    if (isMounted.current) {
      safeNavigate(route, { replace: true });
    }
  }, [data, safeNavigate]);

  return (
    <Dialog open={true} aria-labelledby="modal-title" aria-describedby="modal-description">
      <DialogTitle id={'modal-title'} align={'left'}>
        {t('title')}
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: 'flex',
          p: 4,
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Typography>{t('paragraphTop')}</Typography>
        <img
          alt={t('animationAlt') as string}
          src={'/assets/img/annotation-loading.gif'}
          height={250}
          width={250}
          style={{ borderRadius: theme.shape.borderRadius }}
        />

        <Typography>{t('paragraphBottom')}</Typography>
      </DialogContent>
    </Dialog>
  );
};
